export const TableTitles = {
	Contactos: ["Nombre", "Correo", "Ciudad", "Estado", "Código postal", "Pais"],
	Empresa: ["Nombre", "Ciudad", "Estado", "Código postal", "Pais"],
	Novedad: ["Nombre", "Contenido"],
};
